export const REDUX_CHANGE = '@@redux-form/CHANGE';
export const REDUX_BLUR = '@@redux-form/BLUR';
export const TITLE_TABLE_PAGINATOR_EMPRESAS = 'Inscripciones a bandeja';
export const TITLE_TABLE_PAGINATOR_REPORTS = 'Informes de inscripciones a bandeja';
export const PAGINAR_DATA_REG_EMPRESAS = '@bandeja/paginarDataRegEmpresas';
export const SET_DATA_PAGINAR_REG_EMPRESAS = '@bandeja/setDataPaginarRegEmpresas';
export const SET_DATA_PAGINAR_REPORTS_EMPRESAS = '@bandeja/setDataPaginarReportsEmpresas';
export const OBTENER_DATA_REG_EMPRESAS = '@bandeja/obtenerDataRegEmpresas';
export const OPEN_FORM_BANDEJA = '@bandeja/openFormBandeja';
export const SEARCH_FORM_FROM_TABLE = '@bandeja/searchFormFromTable';
export const VALIDATE_USER_TYPE = '@bandeja/validateUserType';
export const INIT_CHARGE_CATALOG = '@bandeja/initChargeCatalog'
export const VALIDATE_USER_TYPE_SUCCESS = '@bandeja/validateUserTypeSuccess';
export const VISUALIZE_ANEXOS = '@bandeja/visualizeAnexos';
export const CLOSE_MODAL_ANEXOS = '@bandeja/closeModalAnexos';
export const RETURN_HOME_BANDEJA = '@bandeja/returnHomeBandeja';
export const ANULACION_FORM_NAME = 'anulacionForm';
export const ANULACION_FORM_NAME_V2 = 'anulacionFormV2';
export const REGISTRO_AND_APORTES_FORM_NAME = 'ryaForm';
export const ANULACION_FORM_TITLE = 'Anulaciones';
export const DEVOLUCIONES_FORM_NAME = 'devolucionForm';
export const REPORTS_FORM_NAME = 'reportsForm';
export const DEVOLUCIONES_FORM_TITLE = 'Devoluciones';
export const OCULTAR_DEVOLUCIONES = '@bandeja/ocultarDevoluciones';
export const OCULTAR_DE_ANULACIONES = '@bandeja/ocultarDeAnulaciones';
export const ACTIONS_OF_APROVE = '@bandeja/actionsButtonsAprove';
export const MESSAGE_ALERT_SEND = '@bandeja/messageAlertSend';
export const MESSAGE_CONFIRMATION_SEND = '@bandeja/messageConfirmationSend'
export const CLOSE_MODALES = '@bandeja/closeModales';
export const SESSION_VALIDATED = '@bandeja/sessionValidated';
export const SAVED_ACTIONS_VALIDATION = '@bandeja/savedActivations;';
export const SAVED_INFO_USER_BANDEJA = '@bandeja/savedInfoUserBandeja';
export const SEARCH_HISTORIAL_BANDEJA = '@bandeja/searchHistorialBandeja';
export const OPEN_HISTORIAL_BANDEJA = '@bandeja/openHistoryBandeja';
export const TYPE_USER_BANDEJA = '@bandeja/typeUserBandeja';
export const ACTION_AFILIATE_COMPANY = '@bandeja/actionAfiliateCompany';
export const ACTIONS_ON_AFILIATE_RYA = '@bandeja/actionsOnAfiliateCompany';
export const SEND_MESSAGE_CONFIRMATION_RYA = '@bandeja/sendMessageConfirmationRya'
export const LOAD_DOCUMENT_SUCCESS = '@bandeja/loadDocumentSuccess';
export const OPEN_MODAL_CHARGED = '@bandeja/openModalCharged';
export const EXPORT_DATA_FORM_XLSX = '@bandeja/exportDataFormXLSX';
export const OPEN_COMPONENT_INFORMES = '@bandeja/openComponentInformes';
export const PAGINAR_DATA_REPORTS = '@bandeja/paginarDataReports';
export const OBTENER_DATA_REPORTS = '@bandeja/obtenerDataReports';
export const OPEN_REPORT_COMPLETION = '@bandeja/openReportCompletion';
export const INIT_SEARCH_FILTER_REPORT = '@bandeja/initSearchFilterReport';
export const INIT_OPEN_COMPONENT_REPORTS = '@bandeja/initOpenComponentReports';
export const CALL_DINAMIC_DISABLE_LOTE = '@bandeja/callDinamicDisableLote';
export const OPEN_MODAL_DESCARGAR_DATOS = '@bandeja/openModalDescarDatos';
export const DATA_MODAL_DESCARGAR_DATOS = '@bandeja/dataModalDescarDatos';
export const DOWMLOAD_DATA_TABLE_AFILIATIONS = '@bandeja/downloadDataTableAfiliations';
export const SAVE_CONSULTA_REPORTS = '@bandeja/saveConsultaReports';
export const ERROR_GENERAL = '@bandeja/errorGeneral';
export const UPDATE_MSG_SOLICITUD = '@bandeja/updateMsgSolicitud';
export const GESTIONA_MODAL_TRY_CATCH = '@bandeja/gestionAModalTryCatch';
export const OPEN_ANULATION_FORM = '@bandeja/openAnulationForm';
export const ACTION_ANULATION_FORM = '@bandeja/actionAnulationForm';
export const DATA_ANULATION_FORM = '@bandeja/dataAnulationForm';
export const MESSAGE_ANULATION_FORM_RYA = '@bandeja/messageAnulationFormRya';
export const FORM_NAME_ANULATION_FORM = 'anulationForm';


export const DATA_POR_VALIDAR = "No se hallan solicitudes pendientes de validación para su usuario"
export const DEVOLUCIONES_FORM = [

    {
        label: "",
        name: "datosdevolucion",
        type: "section",
        typeForm: "section",
        className: "rs-100",
        fields: [
            {
                //tooltip: "Seleccione el motivo de la anualación",
                label: "Motivo devolución",
                name: "motivoDevolucion",
                placeholder: "Motivo devolución",
                type: "autocomplete",
                typeForm: "autocomplete",
                value: false,
                options: [
                ],
                disabled: false,
                className: "rs-40"
            },
            {
                //tooltip: "Ingresa la observacion pertinente",
                label: "Observación",
                name: "observation",
                placeholder: "Observación",
                type: "text",
                typeForm: "text",
                maxLength: 2000,
                value: false,
                options: [],
                disabled: false,
                className: "rs-60",
                hidden: false
            },

        ]
    }
]

export const panelAnulationdForm = () => {
    return [
        {
            label: "",
            name: "datosFormAnulation",
            type: "section",
            typeForm: "section",
            className: "rs-100",
            fields: [
                {
                    placeholder: `Por favor ingrese el número de la oportunidad asignada a la solicitud a la cual le realizara el proceso de anulación.`,
                    name: "instruccion",
                    type: "information",
                    typeForm: "information",
                    value: false,
                    options: [],
                    disabled: false,
                    className: "rs-100 instruccion2"
                },
                {
                    //tooltip: "Seleccione número de la nomemclatura",
                    label: "Número de oportunidad*",
                    name: "oportunidadNumber",
                    placeholder: "Ingrese el número de oportunidad*",
                    type: "text",
                    typeForm: "text",
                    value: false,
                    options: [],
                    disabled: false,
                    className: "rs-100"
                },
            ]
        }
    ]
}

export const getAddSendAnulation = (handleClean, handleAdd) => {
    return [
        {
            label: "Anular",
            className: "auth-btn-send",
            action: false,
            primary: true,
            style: "primary",
            onClick: handleAdd,

        }, {
            label: "Cancelar",
            className: "auth-btn-cancel",
            action: false,
            primary: false,
            style: "secondary",
            onClick: handleClean

        }
    ]
}

export const panelReportsForm = (handleFilterReport) => {
    return [
        {
            label: "Informes afiliación patronal",
            name: "informesCompanys",
            type: "section",
            typeForm: "section",
            className: "rs-100",
            fields: [
                {
                    tooltip: "Ingresa el año, mes y día en que inició obligaciones como Empleador (ver en RUT en la casilla 47).",
                    label: "Fecha inicial",
                    name: "dateStart",
                    placeholder: " ",
                    type: "date",
                    typeForm: "date",
                    value: false,
                    options: [],
                    disabled: false,
                    className: "rs-30"
                },
                {
                    tooltip: "Ingresa el año, mes y día en que inició obligaciones como Empleador (ver en RUT en la casilla 47).",
                    label: "Fecha final",
                    name: "dateEnd",
                    placeholder: " ",
                    type: "date",
                    typeForm: "date",
                    value: false,
                    options: [],
                    disabled: false,
                    className: "rs-30"
                },
                {
                    //tooltip: "Seleccione el motivo específico de la anualación",
                    label: "Estado afiliación",
                    name: "stateAfilia",
                    placeholder: "Estado afiliación",
                    type: "MLTselect",
                    typeForm: "MLTselect",
                    value: false,
                    options: [],
                    disabled: false,
                    className: "rs-30"
                },
                {
                    //tooltip: "Ingresa la observacion pertinente",
                    label: "Identificación",
                    name: "idCompanyReport",
                    placeholder: "Identificación",
                    type: "number",
                    typeForm: "number",
                    maxLength: 20,
                    value: false,
                    options: [],
                    disabled: false,
                    className: "rs-30",
                    hidden: false
                },
                {
                    //tooltip: "Ingresa la observacion pertinente",
                    label: "N° Oportunidad",
                    name: "idOportunidadReport",
                    placeholder: "N° Oportunidad",
                    type: "number",
                    typeForm: "number",
                    maxLength: 20,
                    value: false,
                    options: [],
                    disabled: false,
                    className: "rs-20",
                    hidden: false
                },
                {
                    //tooltip: "Ingresa la observacion pertinente",
                    label: "N° Doc Afiliación",
                    name: "idDocuReport",
                    placeholder: "N° Doc Afiliación",
                    type: "number",
                    typeForm: "number",
                    maxLength: 30,
                    value: false,
                    options: [],
                    disabled: false,
                    className: "rs-30",
                    hidden: false
                },
                {
                    name: "filterReport",
                    placeholder: "Filtrar",
                    type: "buttonX",
                    typeForm: "buttonX",
                    primary: true,
                    value: false,
                    options: [],
                    hidden: false,
                    disabled: false,
                    className: "rs-20",
                    onClick: handleFilterReport,
                },


            ]
        }
    ]
}

export const REGISTRO_AND_APORTES_FORM = [
    {
        label: "Tipos de sociedad",
        name: "datosrya",
        type: "section",
        typeForm: "section",
        className: "rs-100",
        fields: [
            {
                //tooltip: "Seleccione el motivo específico de la anualación",
                label: "Tipos de sociedad",
                name: "societyType",
                placeholder: "Tipo",
                type: "autocomplete",
                typeForm: "autocomplete",
                value: false,
                options: [
                ],
                disabled: false,
                className: "rs-60 tipos-sociedad"
            },


        ]
    }
]

export const HEADERS_WS = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
    'Access-Control-Allow-Credentials': 'true',
    "Access-Control-Request-Headers": "access-control-allow-credentials,access-control-allow-headers,access-control-allow-methods,access-control-allow-origin,auth,authorization,cache-control,content-type,mode",
    'accept': "application/json, text/plain, */*",
    "Authorization": 'Basic Rk9STVVMQVJJT1NXRUI6WWsyMTkwX3c=',
    "content-type": "application/json",
    "Cache-Control": "no-cache",
    'mode': "opaque ",
}

export const ANULACION_FORM = [
    {
        label: ANULACION_FORM_TITLE,
        name: "datosanulacion",
        type: "section",
        typeForm: "section",
        className: "rs-100",
        fields: [
            {
                //tooltip: "Seleccione el motivo específico de la anualación",
                label: "Motivo anulación",
                name: "motivoAnulacion",
                placeholder: "Motivo anulación",
                type: "autocomplete",
                typeForm: "autocomplete",
                value: false,
                options: [],
                disabled: false,
                className: "rs-40"
            },
            {
                //tooltip: "Ingresa la observacion pertinente",
                label: "Observación",
                name: "observationAnulation",
                placeholder: "Observación",
                type: "text",
                typeForm: "text",
                maxLength: 2000,
                value: false,
                options: [],
                disabled: false,
                className: "rs-60",
                hidden: false
            },

        ]
    }
]

export const ANULACION_FORM_V2 = [
    {
        label: ANULACION_FORM_TITLE,
        name: "datosanulacionform",
        type: "section",
        typeForm: "section",
        className: "rs-100",
        fields: [
            {
                //tooltip: "Seleccione el motivo específico de la anualación",
                label: "Motivo anulación",
                name: "motivoAnulacionForm",
                placeholder: "Motivo anulación",
                type: "autocomplete",
                typeForm: "autocomplete",
                value: false,
                options: [],
                disabled: false,
                className: "rs-40"
            },
            {
                //tooltip: "Ingresa la observacion pertinente",
                label: "Observación",
                name: "observationAnulationForm",
                placeholder: "Observación",
                type: "text",
                typeForm: "text",
                maxLength: 2000,
                value: false,
                options: [],
                disabled: false,
                className: "rs-60",
                hidden: false
            },

        ]
    }
]

export const convertionState = {
    "0": "Borrador",//0 //cuando se crea una postulacion por la empresa pero aun no se ha finalizado    
    "1": "Envido para firma",//1 //Cuando se ha llenado toda la información y se envia a firmar con adobe sign
    "2": "Firmado",  //2 cuando el representante ya ha firmado el pdf y se pasa a la bandeja
    "3": "Validación comercial",//3
    "4": "Anulado",  //4 Cuando por algun motivo ya no se puede continuar el proceso con esa empresa 
    "5": "Devuelta", //5 cuando por algun motivo no se puede continuar y se devuelve al usuario para corregir la postulación
    "6": "Aprobado", //6 Cuando el asesor de comercial aprueba el formulario y se envia al de RyA
    "7": "Devuelta comercial", //7 cuando por algun motivo no se puede continuar y se devuelve al usuario para corregir la postulación
    "8": "Revisado", //8 cuando por algun motivo no se puede continuar y se devuelve al usuario para corregir la postulación
    "9": "Afiliado",//9 Cuandoe el asesor de RyA finaliza el proceso de afiliacion del la inscripción
    "10":"Validacion Corporativo",//10
    "11":"Aprobado Corporativo", //11
    "12":"Firmada sin Asesor"
}

export const HEADER_TABLE_PAGINATOR_EMPRESAS = [
    { field: "dateRegister", header: "Fecha envio", sortable: true },
    { field: "dateReSend", header: "Fecha reenvio", sortable: true },
    { field: "procesoNum", header: "N° registro", sortable: true },
    { field: "idDocu", header: "N° Formulario", sortable: true },
    { field: "sucursalId", header: "Sede", sortable: true },
    { field: "companyType", header: "Tipo empleador", sortable: true },
    { field: "company", header: "Nombre empleador", sortable: true },
    { field: "nitCompany", header: "Identificación empleador", sortable: true },
    { field: "generateBy", header: "Generado por", sortable: true },
    { field: "state", header: "Estado", sortable: true },
    { field: "dateValida", header: "Fecha validación", sortable: true },
    //{ field: "dateDevolved", header: "Fecha devolución", sortable: true },
]

export const MESSAGES_ALERT_PARAMETRIZADOS = [
    { value: "msgRegiDownloadNotBD", download: false, label: "La afiliación que intenta descargar no se encontro en base de datos, por favor inténtelo nuevamente. En caso de presentarse este mensaje una vez más por favor comuníquese con nuestra línea de Servicio al Cliente 602 8862727 opción 2" },
    { value: "msgNotPermitAccessUser", download: false, label: "El usuario no cuenta con los permisos necesarios para acceder a la informacion de la bandeja." },
    { value: "msgDevolCmrSuccess", download: false, label: "El proceso de devolución a comercial ha terminado exitosamente." },
    { value: "msgDevolCmrFailure", download: false, label: "No se pudo realizar el proceso de devolución a comercial correctamente. Si el problema persiste comuniquese con el area de soporte ComfenalcoValle delagente." },
    { value: "msgAfiliaSuccess", download: false, label: "El proceso de afiliación ha terminado exitosamente, la empresa fue afiliada con al siguiente informacion:" },
    { value: "msgAfiliaFailure", download: false, label: "No se pudo realizar el proceso de afiliación correctamente. Si el problema persiste comuniquese con el area de soporte ComfenalcoValle delagente." },
    { value: "msgDevolSuccess", download: false, label: "El proceso de devolución ha terminado exitosamente." },
    { value: "msgDevolFailure", download: false, label: "No se pudo realizar el proceso de devolucion correctamente. Si el problema persiste comuniquese con el area de soporte ComfenalcoValle delagente." },
    { value: "msgAnulaSuccess", download: false, label: "El proceso de anulación ha terminado exitosamente." },
    { value: "msgAnulaFailure", download: false, label: "No se pudo realizar el proceso de anulación correctamente. Si el problema persiste comuniquese con el area de soporte ComfenalcoValle delagente" },
    { value: "msgAprobacionSuccess", download: false, label: "El proceso de aprobación ha terminado exitosamente." },
    { value: "msgAprobacionFailure", download: false, label: "No se pudo realizar el proceso de aprobación correctamente. Si el problema persiste comuniquese con el area de soporte ComfenalcoValle delagente" },
    ]

export const HEADER_TABLE_PAGINATOR_EMPRESAS_COM = [
    { field: "dateRegister", header: "Fecha envio", sortable: true },
    { field: "dateReSend", header: "Fecha reenvio", sortable: true },
    { field: "procesoNum", header: "N° registro", sortable: true },
    { field: "idDocu", header: "N° Formulario", sortable: true },
    { field: "sucursalId", header: "Sede", sortable: true },
    { field: "companyType", header: "Tipo empleador", sortable: true },
    { field: "company", header: "Nombre empleador", sortable: true },
    { field: "nitCompany", header: "Identificación empleador", sortable: true },
    { field: "generateBy", header: "Generado por", sortable: true },
    { field: "state", header: "Estado", sortable: true },
    { field: "dateValida", header: "Fecha validación", sortable: true },
    //{ field: "dateDevolved", header: "Fecha devolución", sortable: true },
]

export const HEADER_TABLE_PAGINATOR_REPORTS = [
    { field: "nroOportunidad", header: "N° oportunidad", sortable: true },
    { field: "dateCreate", header: "Fecha creación", sortable: true },
    { field: "dateModifica", header: "Fecha modificación", sortable: true },
    { field: "dateSend", header: "Fecha envio", sortable: true },
    { field: "dateReSend", header: "Fecha reenvio", sortable: true },
    { field: "idDocu", header: "N° Formulario", sortable: true },
    { field: "state", header: "Estado transacción", sortable: true },
    { field: "idCompany", header: "Identificación", sortable: true },
    { field: "razonSocial", header: "Nombre empleador", sortable: true },
    { field: "empleadorType", header: "Tipo empleador", sortable: true },       
    { field: "nroEmployer", header: "Número trabajadores", sortable: true },
    { field: "dateValidCmr", header: "Fecha valida comercial", sortable: true },     
    { field: "userValidCmr", header: "Usuario valida comercial", sortable: true },    
    { field: "dateValidaRya", header: "Fecha valida RyA", sortable: true },
    { field: "userValidaRya", header: "Usuario valida RyA", sortable: true },
    { field: "dateAfilia", header: "Fecha afiliación", sortable: true },
    { field: "userAfilia", header: "Usuario afiliación", sortable: true },
    { field: "dateDevolCmr", header: "Fecha devol comercial", sortable: true },    
    { field: "userDevolCmr", header: "Usuario devol comercial", sortable: true },    
    { field: "motivoDevolCmr", header: "Motivo devol comercial", sortable: true },
    { field: "obsDevolCmr", header: "Observación devol comercial", sortable: true },
    { field: "dateDevolRya", header: "Fecha devol RyA", sortable: true },
    { field: "userDevolRya", header: "Usuario devol RyA", sortable: true },    
    { field: "motivoDevolRya", header: "Motivo devol RyA", sortable: true },  
    { field: "obsDevolRya", header: "Observación devol RyA", sortable: true },  
    { field: "dateAnula", header: "Fecha anulación", sortable: true },
    { field: "userAnula", header: "Usuario anulación", sortable: true },    
    { field: "motivoAnula", header: "Motivo anulación", sortable: true },
    { field: "obsAnula", header: "Observación anulación", sortable: true },
]

export const getBandejaButtons = [
    {
        label: "Aprobar",
        className: "auth-btn-aprove",
        action: false,
        style: "primary",
        primary: true,
        //onClick: handlerBack

    },
    {
        label: "Rechazar",
        className: "auth-btn-fail",
        action: false,
        primary: true,
        style: "primary",
    },
    {
        label: "Devolver",
        className: "auth-btn-unsend",
        action: false,
        primary: true,
        style: "primary",
    }
]

